import React, { useState } from "react";
import "./App.css";

// To scale to 30 images, you'd ideally have an array of objects
import { images } from "./data";

function App() {
  const [selectedImg, setSelectedImg] = useState(null);

  // Prevention of right-click (Download Protection)
  const preventDefault = (e) => e.preventDefault();

  return (
    <div className="portfolio-container" onContextMenu={preventDefault}>
      <header>
        <h1 className="title">Industrial Photography</h1>
      </header>

      {/* 2-Column Responsive Grid */}
      <div className="grid">
        {images.map((img) => (
          <div
            key={img.id}
            className="grid-item"
            onClick={() => setSelectedImg(img.full)}
          >
            <img src={img.thumb} alt={img.alt} loading="lazy" />
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedImg && (
        <div className="lightbox" onClick={() => setSelectedImg(null)}>
          <div className="lightbox-content">
            <img src={selectedImg} alt="Enlarged view" />
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
